import React from 'react'
import Banner from './Banner';
import MobileNameCard from './MobileNameCard';
import About from './About';
import Skill from './Skill';
import Work from './Work';
import Contact from './Contact';
import Services from './Services';
import ExecutiveExperience from './ExecutiveExperience';
import StatsCounter from './StatsCounter';

const Home = () => {
  return (
    <>
      {/* Mobile: Digital Name Card as first view */}
      <MobileNameCard />

      {/* Tablet & Desktop: Normal Hero Banner */}
      <div className="hidden md:block">
        <Banner />
      </div>

      <StatsCounter />
      <ExecutiveExperience />
      <About />
      <Skill />
      <Work />
      <Services />
      <Contact />
    </>
  )
}

export default Home
